import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { SharedService } from '../services/shared.service';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

/**
 * Use after {@link AuthorizeGuard}. Requires miscellaneous report privilege (view or create)
 * and no IP restriction.
 */
@Injectable({
  providedIn: 'root'
})
export class MiscReportAccessGuard implements CanActivate {
  constructor(
    private sharedService: SharedService,
    private router: Router
  ) { }

  canActivate(
    _next: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    var self = this;
    return this.sharedService.loadUserPrivileges().pipe(
      map(function () {
        var vo = self.sharedService.userPrivilegeVo;
        var allowed = vo && (vo.hasMiscReportAccess || vo.hasMiscReportViewAccess || vo.hasMiscReportCreateAccess);
        if (!allowed) {
          self.router.navigate(['/']);
          return false;
        }
        if (self.sharedService.isIpAddressRestriction) {
          self.router.navigate(['/']);
          return false;
        }
        return true;
      }),
      take(1)
    );
  }
}
